import { useNavigate } from "react-router-dom";
import { FaHome, FaExclamation } from "react-icons/fa";
import LoadingButton from "../utils/Loading";
import LoadingAction from "../utils/LoadingAction";
import React from "react";
import { useState } from "react";

const NotFound = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <section
      className="header z-1 d-flex align-items-center justify-content-center"
      style={{ minHeight: "80vh" }}
    >
      <div className="overlay"></div>
      <div className="text-center z-1">

        <h1
          style={{
            fontSize: "90px",
            fontWeight: "700",
          }}
        >
            <FaExclamation
                size={70}
            />
          404
        </h1>

        <h2 className="mb-3">
          Page Not Found
        </h2>

        <p
          className="text-muted mb-4"
          style={{ maxWidth: "500px" }}
        >
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <LoadingButton
          isLoading={loading}
          onClick={() => 
            LoadingAction(
              setLoading,
              () => navigate("/"),
            )
          }
          className="btn btn-primary rounded-pill px-4"
        >
          <FaHome className="mr-2" />
          Back to Home
        </LoadingButton>

      </div>
    </section>
  );
};

export default NotFound;